import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseViolationNotification = () => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: "has-bm", title: t("license.notifications.violation_title", { productName }) }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "license.notifications.violation_body",
      values: { productName },
      components: { licenseHelp: /* @__PURE__ */ React.createElement(LicenseHelp, null) }
    }
  )));
};
export default LicenseViolationNotification;
